import { Box, Grid, Typography } from "@mui/material"
import ClubTable from "../../../components/common/table/ClubTable"
import { useMediaQuery } from "react-responsive"
import { commaSep } from "../../../components/common/inputs/helper"
import {
  plan1,
  plan2,
  plan3,
  plan4,
  plan5,
  plan6,
  plan7,
  plan8,
  plan9,
  plan10,
  defaultPlan
} from "../../../components/pages/club/companyList"

const Plan = ({ useInSmallSize = false, name, amount, variants }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 })
  const showSmallSize = useInSmallSize || isMobile
  const showCompanies = company => {
    switch (company) {
      case "سطح 1":
        return plan1
      case "سطح 2":
        return plan2
      case "سطح 3":
        return plan3
      case "سطح 4":
        return plan4
      case "سطح 5":
        return plan5
      case "سطح 6":
        return plan6
      case "سطح 7":
        return plan7
      case "سطح 8":
        return plan8
      case "سطح 9":
        return plan9
      case "سطح 10":
        return plan10
      default:
        return defaultPlan
    }
  }

  return (
    <>
      <Grid display='flex' flexDirection='column' gap='4px' padding='1rem'>
        <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", p: 1 }}>
          <Typography variant={showSmallSize ? "h6" : "h5"} color='primary'>
            تسهیلات خرید کالا:
          </Typography>
          <Typography variant={showSmallSize ? "subtitle2" : "subtitle1"}>
            امکان دریافت تسهیلات خرید کالا تا سقف {amount && commaSep(amount)} ریال با توجه به نتیجه اعتبارسنجی بانکی
          </Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", p: 1 }}>
          <Typography variant={showSmallSize ? "h6" : "h5"} color='primary'>
            بسته تخفیفی:
          </Typography>
          <Typography variant={showSmallSize ? "subtitle2" : "subtitle1"}>
            دریافت بسته تخفیفی یک ساله یا دو ساله متناسب با مدت زمان بازپرداخت تسهیلات
          </Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", p: 1 }}>
          <Typography variant={showSmallSize ? "h6" : "h5"} color='primary'>
            حداکثر زمان استفاده :
          </Typography>
          <Typography variant={showSmallSize ? "subtitle2" : "subtitle1"}>
            حداکثر امکان استفاده از هر تخفیف 12 بار در سال (هر ماه یکبار) می باشد.
          </Typography>
        </Box>
      </Grid>
      <Grid>
        <ClubTable
          showSmallSize={showSmallSize}
          data={showCompanies(name)}
          priceInfo1={variants?.[0]?.wageAmount ? `* هزینه بسته برای عضویت ،${variants && variants[0]?.installmentMonths} ماهه ${
            variants && commaSep(variants[0]?.wageAmount || "")
          } ریال`: ""}
          priceInfo2={
            variants && variants[1]?.installmentMonths
              ? ` * هزینه بسته برای عضویت ،${variants && variants[1]?.installmentMonths} ماهه ${
                  variants && commaSep(variants[1]?.wageAmount )
                } ریال`
              : ""
          }
        />
      </Grid>
    </>
  )
}

export default Plan
